import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import img1 from "../assets/carusel_space/img1.jpg";
import img2 from "../assets/carusel_space/img2.jpg";
import img3 from "../assets/carusel_space/img3.jpg";
import img4 from "../assets/carusel_space/img4.jpg";
import img5 from "../assets/carusel_space/img5.jpg";
import img6 from "../assets/carusel_space/img6.jpg";
import img7 from "../assets/carusel_space/img7.jpg";
import img8 from "../assets/carusel_space/img8.jpg";
import img9 from "../assets/carusel_space/img9.jpg";

const carouselImages = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

function FutureSpaceCarousel() {
  return (
    <section className="future-space-carousel" aria-label="Najsavremeniji prostor">
      <div className="future-space-carousel__inner">
        <Swiper
          className="future-space-carousel__slider"
          modules={[Autoplay]}
          loop
          speed={900}
          spaceBetween={18}
          slidesPerView={4}
          autoplay={{
            delay: 1600,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
              spaceBetween: 14,
              centeredSlides: true,
            },
            641: {
              slidesPerView: 2,
              spaceBetween: 14,
              centeredSlides: false,
            },
            993: {
              slidesPerView: 3,
              spaceBetween: 18,
              centeredSlides: false,
            },
            1367: {
              slidesPerView: 4,
              spaceBetween: 18,
              centeredSlides: false,
            },
          }}
          aria-label="Najsavremeniji prostor"
        >
          {carouselImages.map((image, index) => (
            <SwiperSlide className="future-space-carousel__slide" key={image}>
              <img
                src={image}
                alt={`Najsavremeniji prostor ${index + 1}`}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default FutureSpaceCarousel;
